/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "flir_boson_driver";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface Colorlut {
}

export enum Colorlut_Enum {
  kWhiteHot = 0,
  kBlackHot = 1,
  kRainbow = 2,
  kRainbowHc = 3,
  kIronbow = 4,
  kLava = 5,
  kArctic = 6,
  kGlobow = 7,
  kGradedFire = 8,
  kHottest = 9,
  UNRECOGNIZED = -1,
}

export function colorlut_EnumFromJSON(object: any): Colorlut_Enum {
  switch (object) {
    case 0:
    case "kWhiteHot":
      return Colorlut_Enum.kWhiteHot;
    case 1:
    case "kBlackHot":
      return Colorlut_Enum.kBlackHot;
    case 2:
    case "kRainbow":
      return Colorlut_Enum.kRainbow;
    case 3:
    case "kRainbowHc":
      return Colorlut_Enum.kRainbowHc;
    case 4:
    case "kIronbow":
      return Colorlut_Enum.kIronbow;
    case 5:
    case "kLava":
      return Colorlut_Enum.kLava;
    case 6:
    case "kArctic":
      return Colorlut_Enum.kArctic;
    case 7:
    case "kGlobow":
      return Colorlut_Enum.kGlobow;
    case 8:
    case "kGradedFire":
      return Colorlut_Enum.kGradedFire;
    case 9:
    case "kHottest":
      return Colorlut_Enum.kHottest;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Colorlut_Enum.UNRECOGNIZED;
  }
}

export function colorlut_EnumToJSON(object: Colorlut_Enum): string {
  switch (object) {
    case Colorlut_Enum.kWhiteHot:
      return "kWhiteHot";
    case Colorlut_Enum.kBlackHot:
      return "kBlackHot";
    case Colorlut_Enum.kRainbow:
      return "kRainbow";
    case Colorlut_Enum.kRainbowHc:
      return "kRainbowHc";
    case Colorlut_Enum.kIronbow:
      return "kIronbow";
    case Colorlut_Enum.kLava:
      return "kLava";
    case Colorlut_Enum.kArctic:
      return "kArctic";
    case Colorlut_Enum.kGlobow:
      return "kGlobow";
    case Colorlut_Enum.kGradedFire:
      return "kGradedFire";
    case Colorlut_Enum.kHottest:
      return "kHottest";
    case Colorlut_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseColorlut(): Colorlut {
  return {};
}

export const Colorlut = {
  encode(_: Colorlut, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Colorlut {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseColorlut();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): Colorlut {
    return {};
  },

  toJSON(_: Colorlut): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<Colorlut>, I>>(base?: I): Colorlut {
    return Colorlut.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Colorlut>, I>>(_: I): Colorlut {
    const message = createBaseColorlut();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
